<div class="feed-card" (click)="viewFeedDetails()">

  <div class="feed-image" [ngStyle]="{'background-image': 'url(' + getImage() + ')'}">
    <div class="feed-purpose-overlay">
      <div class="feed-purpose">
        {{ donation.purpose }}
      </div>
    </div>
  </div>

  <div class="feed-meta">
    <div class="feed-user">
      <img *ngIf="donation.created_by?.user?.url" [src]="donation.created_by.user.url" alt="user" />
      <ion-icon *ngIf="!donation.created_by?.user?.url" name="person-circle-outline"></ion-icon>
      <div>
        <div class="username">{{ donation.created_by?.user?.name }}</div>
        <div class="time">{{ donation.created_at | fancyDate }}</div>
      </div>
    </div>

    <div class="feed-actions">
      <ion-icon name="logo-whatsapp"></ion-icon>
      <ion-icon name="chatbubble-outline"></ion-icon>
    </div>
  </div>
  <div class="feed-details" *ngIf="details">
    <div class="feed-detail-item">
      <span class="label">🎯 Target Amount:</span>
      <span class="value">₹ {{ donation.target_amount }}</span>
    </div>
    <div class="feed-detail-item">
      <span class="label">💰 Collected:</span>
      <span class="value">₹ {{ donation.collected_amount || 0 }}</span>
    </div>
    <div class="feed-detail-item">
      <span class="label">⏳ Duration:</span>
      <span class="value">{{ donation.start_date | fancyDate }} → {{ donation.end_date | fancyDate }}</span>
    </div>
    <div class="feed-detail-item" *ngIf="donation.remarks">
      <span class="label">📌 Purpose:</span>
      <span class="value">{{ donation.remarks }}</span>
    </div>
  </div>

</div>